import { createSagaAction } from '../../../../shared/sagas'
import { createReducer } from '../../../../shared/reducers'

// Constants
export const constants = {
  ACTIVITY_REPORT_GET_OVERVIEW: createSagaAction('ACTIVITY_REPORT_GET_OVERVIEW'),
  ACTIVITY_REPORT_GET_OVERVIEW_BY_USER: createSagaAction('ACTIVITY_REPORT_GET_OVERVIEW_BY_USER'),
  ACTIVITY_REPORT_GET_CONTACTS_ADDED: createSagaAction('ACTIVITY_REPORT_GET_CONTACTS_ADDED'),
  ACTIVITY_REPORT_GET_COMPANIES_ADDED: createSagaAction('ACTIVITY_REPORT_GET_COMPANIES_ADDED'),
  ACTIVITY_REPORT_GET_LEADS_ADDED: createSagaAction('ACTIVITY_REPORT_GET_LEADS_ADDED'),
  ACTIVITY_REPORT_GET_JOBS_ADDED: createSagaAction('ACTIVITY_REPORT_GET_JOBS_ADDED'),
  ACTIVITY_REPORT_GET_ESTIMATES_ADDED: createSagaAction('ACTIVITY_REPORT_GET_ESTIMATES_ADDED')
}

// Action Creators
export const actions = {
  activityReportGetOverview: ({ filters }) => ({
    type: constants.ACTIVITY_REPORT_GET_OVERVIEW.ACTION,
    filters
  }),

  activityReportGetOverviewByUser: ({ filters }) => ({
    type: constants.ACTIVITY_REPORT_GET_OVERVIEW_BY_USER.ACTION,
    filters
  }),

  activityReportGetContactsAdded: ({ filters }) => ({
    type: constants.ACTIVITY_REPORT_GET_CONTACTS_ADDED.ACTION,
    filters
  }),

  activityReportGetCompaniesAdded: ({ filters }) => ({
    type: constants.ACTIVITY_REPORT_GET_COMPANIES_ADDED.ACTION,
    filters
  }),

  activityReportGetLeadsAdded: ({ filters }) => ({
    type: constants.ACTIVITY_REPORT_GET_LEADS_ADDED.ACTION,
    filters
  }),

  activityReportGetJobsAdded: ({ filters }) => ({
    type: constants.ACTIVITY_REPORT_GET_JOBS_ADDED.ACTION,
    filters
  }),

  activityReportGetEstimatesAdded: ({ filters }) => ({
    type: constants.ACTIVITY_REPORT_GET_ESTIMATES_ADDED.ACTION,
    filters
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.ACTIVITY_REPORT_GET_OVERVIEW.ACTION:
      return { ...state, error: null, loadingOverview: true }
    case constants.ACTIVITY_REPORT_GET_OVERVIEW.SUCCESS:
      return { ...state, error: null, loadingOverview: false, overview: action.payload }

    case constants.ACTIVITY_REPORT_GET_OVERVIEW_BY_USER.ACTION:
      return { ...state, error: null, loadingOverviewByuser: true }
    case constants.ACTIVITY_REPORT_GET_OVERVIEW_BY_USER.SUCCESS:
      return { ...state, error: null, loadingOverviewByUser: false, overviewByUser: action.payload }

    case constants.ACTIVITY_REPORT_GET_CONTACTS_ADDED.ACTION:
      return { ...state, error: null, loadingContactsAdded: true }
    case constants.ACTIVITY_REPORT_GET_CONTACTS_ADDED.SUCCESS:
      return { ...state, error: null, loadingContactsAdded: false, contactsAdded: action.payload }

    case constants.ACTIVITY_REPORT_GET_COMPANIES_ADDED.ACTION:
      return { ...state, error: null, loadingCompaniesAdded: true }
    case constants.ACTIVITY_REPORT_GET_COMPANIES_ADDED.SUCCESS:
      return { ...state, error: null, loadingCompaniesAdded: false, companiesAdded: action.payload }

    case constants.ACTIVITY_REPORT_GET_LEADS_ADDED.ACTION:
      return { ...state, error: null, loadingLeadsAdded: true }
    case constants.ACTIVITY_REPORT_GET_LEADS_ADDED.SUCCESS:
      return { ...state, error: null, loadingLeadsAdded: false, leadsAdded: action.payload }

    case constants.ACTIVITY_REPORT_GET_JOBS_ADDED.ACTION:
      return { ...state, error: null, loadingJobsAdded: true }
    case constants.ACTIVITY_REPORT_GET_JOBS_ADDED.SUCCESS:
      return { ...state, error: null, loadingJobsAdded: false, jobsAdded: action.payload }

    case constants.ACTIVITY_REPORT_GET_ESTIMATES_ADDED.ACTION:
      return { ...state, error: null, loadingEstimatesAdded: true }
    case constants.ACTIVITY_REPORT_GET_ESTIMATES_ADDED.SUCCESS:
      return { ...state, error: null, loadingEstimatesAdded: false, estimatesAdded: action.payload }

    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/reports/general/activityReportActions.js